var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallSpecialistLostIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 20C5 11.7157 11.7157 5 20 5C28.2843 5 35 11.7157 35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20ZM20 37.5C10.335 37.5 2.5 29.665 2.5 20C2.5 10.335 10.335 2.5 20 2.5C29.665 2.5 37.5 10.335 37.5 20C37.5 29.665 29.665 37.5 20 37.5Z",
    fill: "#EB3300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1704 19.8744L25.3352 12.7096C25.8233 12.2214 26.6148 12.2214 27.103 12.7096C27.5911 13.1977 27.5911 13.9892 27.103 14.4773L21.7059 19.8744L27.103 25.2714C27.5911 25.7596 27.5911 26.5511 27.103 27.0392C26.6148 27.5274 25.8233 27.5274 25.3352 27.0392L18.1704 19.8744Z",
    fill: "#EB3300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5783 19.8744L14.4135 27.0392C13.9253 27.5274 13.1338 27.5274 12.6457 27.0392C12.1575 26.5511 12.1575 25.7596 12.6457 25.2714L18.0427 19.8744L12.6457 14.4773C12.1575 13.9892 12.1575 13.1977 12.6457 12.7096C13.1338 12.2214 13.9253 12.2214 14.4135 12.7096L21.5783 19.8744Z",
    fill: "#EB3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSpecialistLostIcon);
export default __webpack_public_path__ + "static/media/call-specialist-lost-icon.1581469099cd870f00b242678a5fc25b.svg";
export { ForwardRef as ReactComponent };